module.exports = __webpack_public_path__ + "static/media/saver-global-logo.5c3b7798.svg";